import { ServiceCategoryFragment } from 'generated/graphql';

const getCategoriesList = (categories: ServiceCategoryFragment[]) => {
  const categoriesList: ServiceCategoryFragment[] = [...categories];
  categoriesList.sort((a: ServiceCategoryFragment, b: ServiceCategoryFragment) => -(b.priority - a.priority));
  return categoriesList;
};

export default getCategoriesList;
